import {
  AsanaLogo,
  AzureBoardsLogo,
  Dismiss,
  GitHub,
  JiraSoftwareLogo,
  Reopen,
  Slack,
  TagOutlined,
  Webhook
} from "@/icons"
import styles from "./ActionTypeIcon.module.scss"
import { ActionTypeIconProps } from "./ActionTypeIcon.types"

import type { ActionType } from "@/api/useWorkflow.types"

const ACTION_TYPE_ICONS: Record<ActionType, React.ReactNode> = {
  webhook: <Webhook />,
  dismiss: <Dismiss className={styles.dismiss} />,
  label: <TagOutlined className={styles.label} />,
  jira_issue: <JiraSoftwareLogo />,
  reopen: <Reopen className={styles.reopen} />,
  slack_message: <Slack />,
  azure_boards_issue: <AzureBoardsLogo />,
  asana_task: <AsanaLogo />,
  github_issue: <GitHub />
}

export const ActionTypeIcon = ({ type }: ActionTypeIconProps) =>
  ACTION_TYPE_ICONS[type] ?? <span></span>
